export const routes = (parentName) => {
  return [
    {
      path: "agahi",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Agahi`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Agahi-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id/edit",
          name: `${parentName}-Agahi-Edit`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Agahi-View",
          component: () => import("./View.vue"),
        },
      ],
    },
  ];
};
